import {useTranslation} from '@/translations/i18n.tsx'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {httpGetUploadedMedia} from '@features/video-upload/http/videoUpload.http.ts'
import {errorHandler, raise} from '@utilities/helpers.ts'
import {z} from 'zod'
import {Media} from '@features/video-upload/types.ts'
import {useEffect} from 'react'
import {ModalBody, ModalFooter} from '@components/ui/modal-atoms'
import {Spinner} from '@components/ui/spinner'
import {Button} from '@components/ui/button'
import {VideoUploadModalWrapper} from '@features/video-upload/components/video-upload-modal-wrapper'

export const FetchingStep = () => {
    const {t} = useTranslation()
    const assignmentId = useVideoUpload(store => store.assignmentId)
    const setStep = useVideoUpload(store => store.setStep)
    const setFile = useVideoUpload(store => store.setFile)

    const getUploadedVideo = async () => {
        try {
            const response = await httpGetUploadedMedia({
                urlParams: {assignmentId: assignmentId ?? raise('assignmentId is nullish')}
            })
            const responseData = z.object({media: Media.nullable()}).parse(response.data)
            setFile(responseData.media ?? null)
            setStep(responseData.media ? 'uploaded' : 'idle')
        } catch (error) {
            errorHandler(error)
        }
    }

    useEffect(() => {
        void getUploadedVideo()
    }, [])

    return (
        <VideoUploadModalWrapper>
            <ModalBody style={{alignItems: 'center'}}>
                <Spinner size={40} />
            </ModalBody>
            <ModalFooter>
                <Button className="w-full" disabled>
                    {t('admin:upload')}
                </Button>
            </ModalFooter>
        </VideoUploadModalWrapper>
    )
}
